import { mapRange, clamp } from '../utils/math'

const useScrollbar = () => {
  const scrollbar = document.querySelector('[data-name="scrollbar"]')
  const inner = scrollbar.querySelector('[data-name="scrollbar-inner"]')
  const thumb = scrollbar.querySelector('[data-name="scrollbar-thumb"]')
  let isClicked = false

  const innerHeight = inner.getBoundingClientRect().height
  let thumbHeight = thumb.getBoundingClientRect().height

  window.lenis.on('scroll', (e) => {
    const progress = e.scroll / e.limit
    thumb.style.transform = `translate3d(0, ${progress * (innerHeight - thumbHeight)}px, 0)`
  })

  const onPointerMove = (e) => {
    if (!isClicked) return

    e.preventDefault()

    const offset = (window.innerHeight - innerHeight) / 2
    const y = mapRange(
      0,
      window.innerHeight,
      e.clientY,
      -offset,
      innerHeight + offset
    )

    const progress = clamp(0, y / innerHeight, 1)
    const newPos = window.lenis.limit * progress

    !lenis.isHorizontal // eslint-disable-line
      ? window.scrollTo(0, newPos)
      : window.scrollTo(newPos, 0)
  }

  function onPointerUp() {
    isClicked = false
  }

  function onPointerDown(e) {
    e.preventDefault()
    if (e.button === 2) return
    isClicked = true
  }

  const handleThumbResize = () => {
    if (!window.lenis || !thumb) return
    const { height, scrollHeight } = window.lenis.dimensions
    thumbHeight = height * (height / scrollHeight)
    thumb.style.height = `${thumbHeight}px`
  }

  handleThumbResize()

  window.addEventListener('resize', handleThumbResize, false)
  window.addEventListener('pointermove', onPointerMove, false)
  window.addEventListener('pointerup', onPointerUp, false)
  thumb.addEventListener('pointerdown', onPointerDown, false)
}

export default useScrollbar
